import { createBehavior } from '@area17/a17-behaviors';

const reveal = createBehavior(
  'reveal',
  {
    handleTriggerClick(evt) {
      evt.preventDefault();
      this.$node.classList.add('reveal:is-open');
      const height = this.$el.scrollHeight;
      this.$node.style.setProperty('--reveal-height', height + 'px');
    },
    handleMedia(evt) {
      if (evt.matches) {
      } else {
        this.$node.classList.remove('reveal:is-open');
      }
    },
  },
  {
    init() {
      this.$el = this.getChild('el');
      this.$trigger = this.getChild('trigger');
      this.$trigger.addEventListener('click', this.handleTriggerClick);
      this.$triggerOuter = this.getChild('trigger-outer');

      if (this.options.bp) {
        const media = window.matchMedia(this.options.bp);
        media.addEventListener('change', this.handleMedia);
      }
    },
    destroy() {
      this.$trigger.removeEventListener('click', this.handleTriggerClick);
    },
  }
);

export default reveal;
